const contentData = [
  {
    title: "Okta案件ノウハウ",
    link: "https://ctcg.sharepoint.com/:p:/t/-256/EfCduMhBI2tFoKslSwzxFmQBBZkanUz0fciUBZxGLq1gbw?e=jg0lcL",
    description:
      "Oktaを使った案件での注意点、躓いたポイント等が確認できます。"
  },
  {
    title: "OktaCIC設定変更操作手順書",
    link: "https://ctcg.sharepoint.com/:p:/t/-256/EWxICk1e7rVEukefjIM-YtsB7i1CVYRMnvpk-7o0VYtVVQ?e=jEONbV",
    description:
      "OktaCIC管理画面側での設定変更内容、手順が確認できます。"
  },
  {
    title: "Oktaパートナーアカウント作成方法",
    link: "https://ctcg.sharepoint.com/:p:/t/-256/EZj0i8nDc5tCtbqW08yYGbkBUj7uJKGSEEVqFbthDrLUTw?e=KgA6bi",
    description:
      "Oktaデモ環境を作成するためのアカウント作成方法が確認できます。"
  }
];

export default contentData;
